import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "components/shared/toast/toast";
import { TEAM } from "services/apiEndpoints";
import { privateDelete, privateGet } from "services/privateRequest";
import { makeQueryString } from "utils/utils";

const initialState = {
    team: [],
    selectedTeam: null,
    teamModalOpen: false,
    isFetching: false,
    totalCount: 0,
    allTeams: [],
    pageNumber: 1,
    pageSize: 10,
}

export const getTeamData = createAsyncThunk("team/getTeamData", async (payload, { rejectWithValue, dispatch, signal }) => {

    try {
        const queryString = makeQueryString(TEAM, payload);

        const res = await privateGet(queryString, { signal });
        dispatch(setPageNumber(payload.pageNumber));
        dispatch(setPageSize(payload.limit));

        return {
            team: res?.data?.data?.teams || [],
            totalCount: res?.data?.data?.totalResponses || 0,

        };
    } catch (error) {
        rejectWithValue(error);
        return error;
    }

    // const res = await privateGet(TEAM)

    // return {
    //     data: res?.data?.data?.teams || [],
    //     totalRoles: res?.data?.length || 0
    // }


})

export const getAllTeamsData = createAsyncThunk("team/getAllTeamsData", async () => {
    // api call here
})

export const deleteTeam = createAsyncThunk("team/deleteTeam", async (id, { dispatch }) => {
    await privateDelete(TEAM, id)
    dispatch(getTeamData())
    toast.success("Team deleted successfully")
})

const teamSlice = createSlice({
    name: "team",
    initialState,
    reducers: {
        setPageNumber: (state, action) => {
            state.pageNumber = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
            state.pageNumber = 1;
        },
        setIsFetching: (state, action) => {
            state.isFetching = action.payload
        },
        setSelectedTeam: (state, action) => {
            state.selectedTeam = action.payload
            state.teamModalOpen = !!action.payload
        },
        setTeamModalOpen: (state, action) => {
            state.teamModalOpen = action.payload
        }
    },
    extraReducers: {
        [getTeamData.pending]: (state, action) => {
            state.isFetching = true
        },
        [getTeamData.fulfilled]: (state, action) => {
            state.team = action.payload.team
            state.totalCount = action.payload.totalCount
            state.isFetching = false
        },
        [getTeamData.rejected]: (state, action) => {
            state.isFetching = false
        },
        [getAllTeamsData.fulfilled]: (state, action) => {
            state.allTeams = action.payload.allTeams
        },
    }
})

export default teamSlice.reducer
export const { setIsFetching, setPageNumber, setPageSize, setSelectedTeam, setTeamModalOpen } = teamSlice.actions